import React from 'react'
import { WithVerificationFormFieldsContext } from './WithVerificationFormFieldsContext'
import { HeadTitle } from 'front-end/src/components/common/head/HeadTitle'
import { VerificationForm } from './VerificationForm'
import { WithVerificationFormik } from 'front-end/src/pages/auth/verification-user-form-step/WithVerificationFormik'
import { VerificationController } from './VerificationController'
import { t } from '@lingui/macro'

type VerificationUserFormStepProps = {
  submit(): Promise<void>
}
export const VerificationUserFormStep: React.FC<VerificationUserFormStepProps> =
  ({ submit }) => (
    <>
      <HeadTitle title={t`Verification`} />
      <WithVerificationFormFieldsContext>
        <VerificationController submit={submit}>
          {(onFormSubmit, verificationLoading) => (
            <WithVerificationFormik onSubmit={onFormSubmit}>
              <VerificationForm verificationLoading={verificationLoading} />
            </WithVerificationFormik>
          )}
        </VerificationController>
      </WithVerificationFormFieldsContext>
    </>
  )
